import { render, staticRenderFns } from "./platformCode.vue?vue&type=template&id=259e1632&scoped=true"
import script from "./platformCode.vue?vue&type=script&lang=js"
export * from "./platformCode.vue?vue&type=script&lang=js"
import style0 from "./platformCode.vue?vue&type=style&index=0&id=259e1632&prod&scoped=true&lang=css"
import style1 from "./platformCode.vue?vue&type=style&index=1&id=259e1632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259e1632",
  null
  
)

export default component.exports